import { useEffect, useRef, useState } from 'react'
import { DigibonAPI } from '../api/digibon'
import { stationSelectors } from '../redux/reducers/station'
import { performHaptics } from '../utils/performHaptics'
import { useAppSelector } from './redux'

export const useProductQuantityChange = (orderKey: string, id: string, readyQuantity: number) => {
    const currentStation = useAppSelector(stationSelectors.currentStation)!

    const [localReadyQuantity, setLocalReadyQuantity] = useState(readyQuantity)
    const [isLoading, setIsLoading] = useState(false)

    const timeoutRef = useRef<NodeJS.Timeout>()

    useEffect(() => {
        setLocalReadyQuantity(readyQuantity)
    }, [readyQuantity, setLocalReadyQuantity])

    const handleQuantityChange = async (quantity: number) => {
        performHaptics()

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }

        setLocalReadyQuantity((prevState) => prevState + quantity)

        timeoutRef.current = setTimeout(async () => {
            try {
                setIsLoading(true)

                await DigibonAPI.updateProductQuantity(
                    orderKey,
                    currentStation.code,
                    id,
                    localReadyQuantity + quantity
                )

                setIsLoading(false)
            } catch (e) {
                setLocalReadyQuantity(readyQuantity)
                setIsLoading(false)
            }
        }, 1000)
    }

    return [localReadyQuantity, handleQuantityChange, isLoading] as [
        number,
        (quantity: number) => void,
        boolean
    ]
}
